import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { useCallContext } from '@gem/call/CallView/CallView.context';
import { AddPeopleButton } from '@gem/call/CallView/FullScreenCallView/Shared/AnimatedRightPanel/RightPanel/AddPeopleButton/AddPeopleButton';
import { ShareInviteLink } from '@gem/call/CallView/FullScreenCallView/Shared/AnimatedRightPanel/RightPanel/ShareInviteLink/ShareInviteLink';
import { MemberList } from '@gem/call/CallView/Shared/MemberList/MemberList';
import { PermissionRequestButton } from '@gem/call/CallView/Shared/PermissionRequestsButton/PermissionRequestButton';
import { WaitingRoomList } from '@gem/call/CallView/Shared/WaitingRoomList/WaitingRoomList';
import { ParticipantsControlType } from '@gem/call/Model/callModel.types';
import { useTranslation } from '@gem/modules/i18n';
import { customScrollStyles } from '@gem/ui-kit';

import { AdmitAllButton } from './AdmitAllButton/AdmitAllButton';
import styles from './RightPanel.styles.m.css';
import { RightPanelHeader } from './RightPanelHeader/RightPanelHeader';

export const RightPanel = observer(() => {
  const { call, callController } = useCallContext();
  const { t } = useTranslation();

  if (!call) {
    return null;
  }

  return (
    <div className={styles.container}>
      <RightPanelHeader />
      <div className={classNames(styles.memberListContainer, customScrollStyles.container)}>
        {call.isMeInitiatorOwnerOrAdmin && !call.isPermissionsRequestsEmpty && (
          <PermissionRequestButton />
        )}
        {call.waitingRoom.enabled &&
        call.waitingRoom.requestedMembersArray.length &&
        call.isMeInitiatorOwnerOrAdmin ? (
          <>
            <div className={styles.waitingRoomDescription}>
              <div className={styles.waitingRoomDescriptionText}>
                {t('calls_participants_waiting_room_section_name', {
                  0: call?.waitingRoom.requestedMembersArray.length || 0,
                })}
              </div>
              <AdmitAllButton />
            </div>
            <WaitingRoomList />
          </>
        ) : null}

        <div className={styles.description}>
          {call.uiFeatures.participantsControlType === ParticipantsControlType.WithMaxNumber
            ? t('calls_users_on_call', {
                0: call?.members.memberDevicesOnCallList.length || 0,
                1: call?.members.memberList.length || 0,
              })
            : null}
          {call.uiFeatures.participantsControlType === ParticipantsControlType.TotalNumber ||
          call.isUnauthorizedCall
            ? t('calls_participants_on_call_section_name', {
                0: call?.members.memberDevicesOnCallList.length || 0,
              })
            : null}
        </div>
        {!call.isUnauthorizedCall ? (
          <>
            <AddPeopleButton
              call={call}
              callController={callController}
            />
            <ShareInviteLink call={call} />
          </>
        ) : null}
        <MemberList />
      </div>
    </div>
  );
});
